import React from 'react'
import '../../App.css'
import Navbar from '../../components/Navbar'
import './Auth.css'
import Home from '../../components/Home'

function Role() {
    return (
        <>
            <div>
            <Navbar />
            <Home/>
            </div>
        </>
    )
}

export default Role